import React, { useRef, FC } from "react";
import { message } from "antd";
import { IYhFormRef, FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useDiscernModel } from "../../discernModel";
import { discernService, ILabelResultOne } from "../../discernService";
import { RouterParamType } from "@/model/navModel";


export const LabelResultDrawer: FC<RouterParamType> = ({ id }) => {
	const { LabelResultDrawer: { visible, mode, record }, setLabelResultDrawer } = useDiscernModel();
	const formRef = useRef<IYhFormRef>();

	const onCancel = () => {
		setLabelResultDrawer({ visible: false, mode: "add" });
	}

	//表单提交
	const onSubmit = async () => {
		formRef.current?.validateFields().then((val: ILabelResultOne) => {
			if (mode === "edit") {
				discernService.labelResultUpdate({ ...val, distinguishId: id, id: record?.id }).then(res => {
					message.success("开标结果标注成功");
					onCancel();
				})
			} else {
				discernService.labelResultInsert({ ...val, distinguishId: id }).then(res => {
					message.success("开标结果标注修改成功");
					onCancel();
				})
			}
		}).catch(err => {
			message.warning(getFormValidatorErrText(err));
		})
	}



	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 6 },
		formValues: mode === "edit" ? record ?? {} : {},
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "投标公司",
				fieldName: "bidCompany",
				span: 24,
				rules: [{ required: true, message: "请输入投标公司" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "投标类型",
				fieldName: "bidModel",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "投标数量",
				fieldName: "num",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "投标金额",
				fieldName: "bidPrice",
				span: 24,
				rules: [{ required: true, message: "请输入分类名称" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "中标公司",
				fieldName: "hitCompany",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "中标金额",
				fieldName: "hitPrice",
				span: 24,
				rules: [{ required: true, message: "请输入分类名称" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "状态",
				fieldName: "status",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "原因",
				fieldName: "reason",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "开标日期",
				fieldName: "openTime",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "备注",
				fieldName: "note",
				span: 24,
			}
		]
	};
	return (
		<YHDrawer
			{...{
				title: `开标结果标注`,
				visible,
				onCancel,
				okText: "保存",
				onOk: onSubmit,
				maskClosable: false,
				drawerWidth: 490
			}}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	)
}
